<template>
  <div
    v-if="debitNote"
    @click.stop="debitNoteView"
    class="sale-document-body md__border border-radius bg-color-write p-3 mb-2 cursor-point"
    :class="{ 'signing-card--active': isSigning }"
  >
    <div class="sale-document-info">
      <div class="sale-document-description d-flex justify-content-between">
        <div class="info">
          <p class="m-0 text-color-primary str-limit-space">
            N° {{ debitNote.identification_document }}
          </p>
          <p class="m-0 font-bold text-color-primary str-limit-space">
            {{ debitNote.invoice.client.name }}
          </p>
          <p class="m-0">
            <small>
              <span class="font-semi-bold mr-2"
                >Fact: {{ debitNote.invoice.number_invoice }}</span
              >
            </small>
          </p>
        </div>
        <div class="sale-document-number">
          <h5 class="h5 font-bold">
            <FormatAmount :amount="debitNote.total" />
          </h5>
          <span class="card-date">{{
            formatFullDate(debitNote.created_at)
          }}</span>
        </div>
      </div>
    </div>

    <div
      class="sale-document-actions d-flex justify-content-between align-items-center mt-4"
    >
      <div class="status d-flex">
        <template v-if="isSigning">
          <span class="signing-badge">
            <span class="signing-badge__spinner"></span>
            Firmando...
          </span>
        </template>
        <StatusReadDocumentsComponent
          v-else
          :status.sync="debitNote.status"
          typeStatus="short"
        />
      </div>
      <div class="next" @click.stop>
        <DebitNoteOptionsByStatus
          :status="debitNote.status"
          :id="debitNote.id"
          @goPage="goRouter"
          @onSigningStart="isSigning = true"
          @onSigningDone="onSigningDone"
          @onSigningError="isSigning = false"
          @onDocDeleted="id => $emit('onDocDeleted', id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StatusReadDocumentsComponent from "../../../../components/StatusReadDocuments";
import FormatAmount from "@/components/General/FormatAmount";
import DebitNoteOptionsByStatus from "./DebitNoteOptionsByStatus";

export default {
  name: "DebitNoteCardComponent",
  data() {
    return { isSigning: false };
  },
  computed: {},
  methods: {
    onSigningDone({ id, data }) {
      this.isSigning = false;
      if (data) this.$emit("onDocUpdate", { id, data });
    },
    formatFullDate(date) {
      if (!date) return "";
      const normalized = /^\d{4}-\d{2}-\d{2}$/.test(date) ? date + "T00:00:00" : date;
      const d = new Date(normalized);
      const months = [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ];
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    debitNoteView() {
      this.goRouter("sales.debitNote.view", {
        id: this.debitNote.id
      });
    }
  },
  components: {
    StatusReadDocumentsComponent,
    FormatAmount,
    DebitNoteOptionsByStatus
  },
  props: {
    debitNote: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.signing-card--active {
  opacity: 0.45;
  pointer-events: none;
  transition: opacity 0.2s ease;
}
.signing-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 500;
  color: #534ab7;
  background: #eeedfe;
  border-radius: 10px;
  padding: 2px 8px;
  &__spinner {
    width: 10px;
    height: 10px;
    border: 1.5px solid #eeedfe;
    border-top-color: #534ab7;
    border-radius: 50%;
    animation: signing-card-spin 0.7s linear infinite;
  }
}
@keyframes signing-card-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
